import React from 'react';
import { LogOut, User } from 'lucide-react';

const Header = ({ user, onLogout, onProfileClick, onLogoClick }) => {
  return (
    <header className="main-header">
      <div className="header-left">
        <div 
          className="logo" 
          onClick={() => onLogoClick && onLogoClick()}
          style={{ cursor: 'pointer' }}
        >
          <img src="/logo.ico" alt="LogHog" className="logo-icon" />
          {/* LogHog */}
        </div>
      </div>
      <div className="header-right">
        {user && (
          <>
            {onProfileClick && (
              <button className="btn-secondary" onClick={onProfileClick} title="Profile">
                <User size={16} />
                <span className="header-user btn-text">{user.email || user.name}</span>
                
              </button>
            )}
            {onLogout && (
              <button className="btn-secondary" onClick={onLogout} title="Logout">
                <LogOut size={16} />
                <span className="header-user btn-text">Logout</span>
              </button>
            )}
          </>
        )}
      </div>
    </header>
  );
};

export default Header;
